import React, { Component } from 'react'
import PureComponent from '../../pure'
import TextField from "@material-ui/core/TextField";

import  sAction  from "sAction";
import confProd from "./productLineConfig";
import Button from "../../formElements/Button";

class QTotal extends PureComponent{
    
    valChange(way, ev){
        let newVal = sAction.parseNumber(ev.target.value);
        sAction.updateDetailCustom("field", {way:way, value: newVal});
        //sAction.dataSet(way, newVal);
    }

    render(){
    var data = this.props.data;
    let total_list_price = 0;
    let total_discount_amount = 0;
    const way = this.props.way;
    const keyPre = Date.now();
    const readonly = this.props.readonly;

    const sums = sAction.calcSums(way, {type : "total", data: data, cenotvorba: this.props.cenotvorba});
    const conf = confProd.sums;

    var renderComp = [];
    var firstFiller = null;

    var readonlyClass = "";
    
    if(!readonly){
        renderComp.push(
            <Button 
                className="acmAddGroupBtn"
                key={"addBtnGr"}
                variant="text" 
                onClick={() => sAction.updateDetailCustom("addProdGroup", {way:way+"/groups"})}>
                <div className="buttonIcon icon-addGroupIcon" />
                {sAction.translate("LBL_ADD_GROUP", "Quotes")}
            </Button>
        );
        firstFiller = <div key="firstFiller" style={{width:"40px"}} />
    }
    else{
        readonlyClass = " readOnly";
        firstFiller = <div key="firstFiller" style={{width:"14px"}} />
    }
    
    renderComp.push(
        <div key="secondFiller" style={{width:"45%"}} />
    );

    var self = this;


    return <div className="QTotalContainer">
        <div className="QTotalContainerTopBorder" />
        <div className="QTotalContainerFirstRow QTotalContainerRow">
            {!readonly &&
                <Button 
                    className="acmAddGroupBtn"
                    key={"addBtnGr"}
                    variant="text" 
                    onClick={() => sAction.updateDetailCustom("addProdGroup", {way:way+"/groups"})}>
                    <div className="buttonIcon icon-addGroupIcon" />
                    {sAction.translate("LBL_ADD_GROUP", "Quotes")}
                </Button>
            }
            {firstFiller}
            <div key="secondFiller" style={{width:"33%"}} />
            <div style={{width: "9%"}} className="amountsContainer" key={"sum_total_cost_price"}>
                <div>{sAction.translate("LBL_TOTAL_COST_PRICE", "Quotes")}</div>
                <div>{sAction.formatNumber(sums["total_cost_price"])}</div>
            </div>
            <div key="thirdFiller" style={{width:"9%"}} />
            <div style={{width: "9%"}} className="amountsContainer" key={"sum_total_list_price"}>
                <div>{sAction.translate("LBL_SUBTOTAL", "Quotes")}</div>
                <div>{sAction.formatNumber(sums["total_list_price"])}</div>
            </div>
            
            <div style={{width: "9%"}} className="amountsContainer" key={"sum_total_discount_amount"}>
            </div>
            <div className={"QTotalContainerRowSumLbl SumsDiscouPriceContainer"+readonlyClass} style={{width:"11%"}}>{sAction.translate("LBL_NEW_SUB", "Quotes")}</div>
            <div style={{width: "13%"}} className="amountsContainer" key={"sum_total_discount_price"}>
                <div className="SumsDiscouPriceContainer">{sAction.formatNumber(sums["total_discount_price"])}</div>
            </div>
        </div>
        <div className="QTotalContainerRow">
            <div className={"QTotalContainerRowSumLbl"+readonlyClass} >{sAction.translate("LBL_TOTAL_MARGIN", "Quotes")}</div>
            <div style={{width: "13%"}} className="amountsContainer" key={"sum_total_margin"}>
                <div>{sAction.formatNumber(sums["total_margin"])}</div>
            </div>
        </div>
        <div className="QTotalContainerRow">
            <div className={"QTotalContainerRowSumLbl"+readonlyClass} >{sAction.translate("LBL_TAX", "Quotes")}</div>
            <div style={{width: "13%"}} className="amountsContainer" key={"sum_total_tax"}>
                <div>{sAction.formatNumber(sums["total_tax"])}</div>
            </div>
        </div>
        <div className="QTotalContainerRow">
            <div className={"QTotalContainerRowSumLbl"+readonlyClass} >{sAction.translate("LBL_SHIPPING", "Quotes")}</div>
            <div style={{width:"13%"}} className="amountsContainer sumRow" key={"sum_shipping"}>
                <TextField
                className="priceInput"
                style={{width: '100%'}}
                margin="normal"
                variant="outlined"
                id="shipping"
                type="text"
                key={keyPre+"_shipping"}
                defaultValue={sAction.formatNumber(data["shipping"])}
                onBlur={(ev) => self.valChange(way+"/shipping", ev)}
                disabled={readonly}
                style={{width:"100%"}}
                />
            </div>
        </div>
        <div className="QTotalContainerRow">
            <div className={"QTotalContainerRowSumLbl"+readonlyClass} >{sAction.translate("LBL_TOTAL", "Quotes")}</div>
            <div style={{width: "13%"}} className="amountsContainer" key={"sum_total"}>
                <div>{sAction.formatNumber(sums["total"])}</div>
            </div>
        </div>

    </div>;
    }
}

export default QTotal
